import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-sales-status-message-modal-v3',
  templateUrl: './sales-status-message-modal-v3.component.html',
})

export class SalesStatusMessageModalComponentV3{
  @Input() visible: boolean = false;
  @Input() type: 'success' | 'error' = 'success';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() buttonLabel: string = 'Continuar';
  @Input() modal: boolean = true;
  @Input() draggable: boolean = false;
  @Input() resizable: boolean = false;
  @Input() closable: boolean = false;
  @Input() buttonIcon: string = 'pi pi-angle-right';
  @Input() buttonIconPos: 'left' | 'right' = 'right';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onButtonClick = new EventEmitter<void>();

  onVisibleChange(value: boolean) {
    this.visible = value;
    this.visibleChange.emit(value);
  }

  handleButtonClick() {
    this.onButtonClick.emit();
  }
}
